<template>
  <v-container class="pa-0" fluid>
    <!-- Snackbar -->
    <SnackbarMessage ref="snackbar" />

    <!-- Layout paginado -->
    <PaginatedLayout :items="customers" @update-page="updatePage" class="pb-15">
      <!-- Header -->
      <template v-slot:header>
        <DeltiaCard>
          <!-- Columna para el título -->
          <v-col cols="12" md="7" class="mb-6">
            <p class="display-1 font-weight-bold mb-0 pb-0">Clientes</p>
          </v-col>
          <!-- Columna para el botón de agregar clientes -->
          <v-col cols="12" md="5" class="mb-6">
            <NewClient
              @new-client="customerCreated"
              @client-error="onError"
            ></NewClient>
          </v-col>
        </DeltiaCard>
      </template>
      <!-- Clientes -->
      <template v-slot:items>
        <!-- Pantalla de carga -->
        <LoadingLayout v-if="isLoading">
          <LinearLoading>
            Cargando clientes
          </LinearLoading>
        </LoadingLayout>
        <!-- Fila que indica titulares de las columnas -->
        <template v-else>
          <!-- Filas para los items de cada cliente -->
          <CustomerItem
            v-for="customer in customers.docs"
            :key="customer._id"
            :customer="customer"
          />
        </template>
      </template>
    </PaginatedLayout>
  </v-container>
</template>

<script>
// Importar componentes
import LinearLoading from "@/components/Loading/Linear";
import LoadingLayout from "@/layouts/LoadingLayout";
import PaginatedLayout from "@/layouts/PaginatedLayout";
import SnackbarMessage from "@/components/SnackbarMessage";
import DeltiaCard from "@/components/DeltiaCard";
import NewClient from "@/components/clients/NewClient";
import CustomerItem from "@/components/clients/CustomerItem";

// Importar servicios
import CustomersServices from "@/services/CustomersServices";

export default {
  components: {
    LoadingLayout,
    LinearLoading,
    PaginatedLayout,
    SnackbarMessage,
    DeltiaCard,
    NewClient,
    CustomerItem
  },
  data() {
    return {
      customers: { docs: [] },
      isLoading: true
    };
  },
  created: async function() {
    await this.updatePage();
  },
  methods: {
    updatePage: async function(page = 1) {
      try {
        // Mostrar pantalla de carga
        this.isLoading = true;

        // Obtener clientes
        this.customers = await CustomersServices.getCustomersByBusinessId(page);

        // Ocultar pantalla de carga
        this.isLoading = false;
      } catch (err) {
        this.onError(err.message);
      }
    },
    customerCreated: async function() {
      // Mostrar mensaje
      this.$refs.snackbar.showSuccessMessage("Cliente registrado con éxito");

      // Actualizar la página
      await this.updatePage();
    },
    onError: function(errorMessage) {
      // Mostrar error
      this.$refs.snackbar.showError(errorMessage);
    }
  }
};
</script>
